import React from 'react';
import Linkify from 'linkify-react';
import { looksLikeHtml, sanitizeNoticeHtml } from './noticeHtml';

const linkifyOptions = {
  componentDecorator: (decoratedHref: string, decoratedText: string, key: number | string) => (
    <a className="link" href={decoratedHref} key={key} target="_blank" rel="noopener noreferrer">
      {decoratedText}
    </a>
  ),
};

const NoticeContent = ({ content }: { content?: string | null }) => {
  if (!content) return null;
  if (!looksLikeHtml(content)) {
    return <Linkify options={linkifyOptions}>{content}</Linkify>;
  }
  return (
    <div
      className="notice_rich"
      dangerouslySetInnerHTML={{ __html: sanitizeNoticeHtml(content) }}
    />
  );
};

export default NoticeContent;
